import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: {
          Welcome: {
            text: 'Welcome to IURIX!',
          },
          IT_CATALIZES_YOUR_BUSINESS: {
            text: "I.T. CATALIZES YOUR BUSINESS!",
          },
          Contact: {
            text: "Contact us"
          },
          Creating_software_for_a_purpose: {
            text: "Creating software for a purpose: to help people succeed in their business.",
          },
          Finance: {
            text: "Finance"
          },
          GET_STARTED: {
            text: "GET STARTED",
          },
          Jobs: {
            text: "Jobs"
          },
          Portfolio: {
            text: "Portfolio"
          },
          Services: {
            text: "Services"
          },
          SIGN_UP: {
            text: "SIGN UP"
          },
          SIGN_IN: {
            text: "SIGN IN"
          },
          Terms_Conditions: {
            text: "Terms & Conditions",
          },
          Privacy_Policy: {
            text: "Privacy Policy",
          },
          Blog: {
            text: "Blog",
          },
          Copyrights: {
            text: "IURIX © 2022. All rights reserved."
          },
          Currencies: {
            text: "Currencies"
          },
          Dates: {
            text: "Dates"
          },
        },
      },
      pt: {
        translation: {
          Welcome: {
            text: "Bem-vindo à IURIX!",
          },
          IT_CATALIZES_YOUR_BUSINESS: {
            text: "T.I. ACELERA O SEU NEGÓCIO!",
          },
          Creating_software_for_a_purpose: {
            text: "Criamos software com um propósito: ajudar o cliente a alcançar o sucesso.",
          },
          Finance: {
            text: "Finanças"
          },
          GET_STARTED: {
            text: "VEJA MAIS",
          },
          Jobs: {
            text: "Vagas"
          },
          Portfolio: {
            text: "Portfólio"
          },
          Services: {
            text: "Serviços"
          },
          Contact: {
            text: "Contato"
          },
          SIGN_UP: {
            text: "ENTRAR"
          },
          Terms_Conditions: {
            text: "Termos & Condições",
          },
          Privacy_Policy: {
            text: "Política de Privacidade",
          },
          Copyrights: {
            text: "IURIX ©2022. Todos os direitos reservados."
          },
          Currencies: {
            text: "Câmbio"
          },
        },
      },
      fr: {
        translation: {
          Welcome: {
            text: "Bienvenue sur IURIX!",
          },
          IT_CATALIZES_YOUR_BUSINESS: {
            text: "L'INFORMATIQUE ACCÉLÈRE VOTRE ENTREPRISE!",
          },

          Portfolio: {
            text: "Portfefeuille"
          },
          Services: {
            text: "Les Services"
          },
          Contact: {
            text: "Nous Contacter"
          },
          SIGN_UP: {
            text: "S'inscrire"
          },
        },
      },
    },
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;